import React, { useEffect, useRef } from "react";
import vector from "../../assets/img/vector.png";
import me from "../../assets/img/me_1.jpg";
import me2 from "../../assets/img/me_2.jpg";
import me3 from "../../assets/img/me_3.jpg";
import { useMediaQuery } from "react-responsive";
import AboutMeMobileView from "./about-me-mobile-view/AboutMeMobileView";
import { motion } from "motion/react";
import "./AboutMe.css";

const AboutMe = (props) => {
  const myRef = useRef(null);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  useEffect(() => {
    if (props.sd === "aboutme") {
      console.log(props.sd);
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={
        isTabletOrMobile
          ? {
              width: "100%",
              height: "100%",
              position: "relative",
              padding: "15px",
              display: "flex",
              justifyContent: "space-between",
            }
          : {
              width: "100%",
              height: "100%",
              position: "relative",
              paddingLeft: "30px",
              display: "flex",
              justifyContent: "space-between",
            }
      }
    >
      <div style={isTabletOrMobile ? { width: "100%" } : { width: "55%" }}>
        <h1
          style={{
            fontSize: isTabletOrMobile ? "45px" : "80px",
            fontWeight: "bold",
            color: "#155BDD",
            textAlign: isTabletOrMobile ? "center" : "",
            fontFamily: "Tenorite",
          }}
        >
          Who am I...
        </h1>
        <br />
        {isTabletOrMobile ? (
          <AboutMeMobileView />
        ) : (
          <p
            style={{
              fontSize: "25px",
              color: "#616161",
              textAlign: "justify",
              fontFamily: "Tenorite",
              marginBottom: "30px",
            }}
          >
            Hi... I am Thushal. I am a 24 year old graduate and also an
            undergraduate who is passionate on full-stack web development,
            mobile app development and video game development. I am a graduate
            from SLIIT with a BSc (Hons) in Information Technology specialized
            in Software Engineering and currently reading Bachelor in
            Information Communication Technology specializing in Games and
            Animation development from University of Kelaniya. I am also a
            member of British Computer Society completed upto Certificate in IT
            level. I have also done Diploma in Information Technology from ESOFT
            metro campus. My preferred programming language is JavaScript and my
            preferred tech stacks are the MERN stack for web development,
            Flutter and Android Studio for mobile application development and
            Unity game engine for game development. I am very keen and
            interested on solving real-world problems using software development
            knowledge that I have and also learning new and trending
            technologies. Fun fact about me is that I am very much enthusiast on
            tech events and in my free time I used to play video games and
            explore new technologies. Also I am a huge WWE wrestling fan and
            also I maintain a fragrance collection contains lots of branded
            fragrances.
          </p>
        )}
      </div>
      {isTabletOrMobile ? (
        ""
      ) : (
        <>
          <div
            style={{
              width: "95%",
              display: "flex",
              justifyContent: "end",
              position: "absolute",
            }}
          >
            <div
              style={{
                width: "35%",
                display: "flex",
                justifyContent: "end",
                flexDirection: "column",
                alignItems: "end",
              }}
            >
              <motion.div
                id="myImg"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                <img
                  src={me3}
                  style={{
                    height: "350px",
                    borderRadius: "100%",
                  }}
                />
              </motion.div>
              <motion.div
                id="myImg"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                <img
                  src={me2}
                  style={{
                    height: "250px",
                    borderRadius: "100%",
                  }}
                />
              </motion.div>
              <motion.div
                id="myImg"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                <img
                  src={me}
                  style={{
                    height: "330px",
                    borderRadius: "100%",
                  }}
                />
              </motion.div>
            </div>
          </div>
          <div>
            <img src={vector} />
          </div>
        </>
      )}
    </div>
  );
};

export default AboutMe;
